import dayjs from 'dayjs';
import pdfMake from "pdfmake/build/pdfmake";
import vfsFonts from "pdfmake/build/vfs_fonts";   // ไฟล์ที่ generate ไว้เอง
import { formatCurrency, numberToThaiText } from '../utils/helpers';
import { loadImageBase64 } from "../utils/loadImageBase64";
import { Radius } from 'lucide-react';

// ตั้งค่าให้ pdfMake ใช้ฟอนต์จาก vfs_fonts
pdfMake.vfs = vfsFonts;
pdfMake.fonts = {
    THSarabunNew: {
        normal: 'THSarabunNew.ttf',
        bold: 'THSarabunNew Bold.ttf',
        italics: 'THSarabunNew Italic.ttf',
        bolditalics: 'THSarabunNew BoldItalic.ttf'
    }
};

// กำหนด font สำหรับ pdfMake
const initializePdfMake = () => {
    if (window.pdfMake) {
        // กำหนด font เป็น default fonts ของ pdfMake
        window.pdfMake.fonts = {
            THSarabunNew: {
                normal: 'THSarabunNew.ttf',
                bold: 'THSarabunNew Bold.ttf',
                italics: 'THSarabunNew Italic.ttf',
                bolditalics: 'THSarabunNew BoldItalic.ttf'
            }
        };
    }
};



//ใช้ฟังชั่น สร้างไฟล์ PDF
export const generatePendingDeliveryPDF = async (documentData, company = {}, vatMode, calcValues) => {

    //กรณีใช้ local logo:   process.env.PUBLIC_URL + "/assets/ttlogo.png"
    const logoBase64 = await loadImageBase64(`${process.env.REACT_APP_API_URL}/uploads/${company?.logo_path}`);
    console.log('ข้อมูลในส่งของชั่วคราว', documentData);

    const delivery = documentData;

    // ตรวจสอบว่า pdfMake โหลดแล้วหรือยัง
    if (!window.pdfMake) {
        throw new Error('pdfMake library is not loaded');
    }

    // กำหนด font
    initializePdfMake();

    const docDefinition = {
        pageSize: 'A4',
        pageMargins: [23, 30, 23, 50], //left, top, right, bottom
        defaultStyle: {
            font: 'THSarabunNew',
            fontSize: 14
        },
        styles: {
            header: {
                fontSize: 20,
                bold: true,
                alignment: 'center',
                margin: [0, 0, 0, 20]
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            notes: {
                fontSize: 14,
                bold: false,
                margin: [0, 10, 0, 5]
            },
            tableHeader: {
                bold: true,
                fontSize: 16,
                Radius: 10,
                color: 'black',
                fillColor: '#E3F2FD' // 💙 สีฟ้าอ่อน
            },
            bathText: {
                fontSize: 15,
                bold: true,
                alignment: 'left'
            },
            total: {
                fontSize: 16,
                bold: true,
                alignment: 'right'
            }
        },
        content: [
            // หัวข้อ
            {
                text: 'ใบค้างส่งสินค้า',
                bold: true, fontSize: 25,
                alignment: 'right',
                color: '#054eed', // 💙 สีฟ้าอ่อน
                margin: [0, 0, 45, 0]
            },

            // =============================
            // ส่วนข้อมูลบริษัท (มีพื้นหลังฟ้าอ่อน)
            // =============================
            {
                table: {
                    widths: ['60%', '40%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        ...(logoBase64
                                            ? { image: logoBase64, width: 80, alignment: 'left', margin: [0, 18, 0, 0] }
                                            : { text: '', fontSize: 18, bold: true, margin: [0, 18, 0, 0] }
                                        ),
                                    },
                                    {
                                        lineHeight: 0.8,
                                        stack: [
                                            { text: company.company_name || 'ชื่อบริษัท', bold: true, fontSize: 16 },
                                            { text: company.address || 'ที่อยู่บริษัท', margin: [0, 0, 0, 0] },
                                            { text: `โทรศัพท์: ${company.phone || 'หมายเลขโทรศัพท์'}`, margin: [0, 0, 0, 0] },
                                            { text: company.tax_id ? `เลขที่ภาษี: ${company.tax_id} ${company.branch_name === '-' ? '' : '(' + company.branch_name + ')'}` : '', margin: [0, 0, 0, 0] }
                                        ],
                                        margin: [10, 18, 0, 10]
                                    },
                                ],
                                border: [false, false, false, false],
                                margin: [0, -65, 0, 10]
                            },
                            {
                                stack: [
                                    {
                                        canvas: [
                                            {
                                                type: 'rect',
                                                x: 0,
                                                y: 0,
                                                w: 160, // กำหนดความกว้างของพื้นหลัง (ปรับได้)
                                                h: 50,  // กำหนดความสูงของพื้นหลัง (พอดีข้อความ)
                                                r: 10,  // ความมนของขอบ 10px
                                                color: '#E3F2FD' // 💙 สีฟ้าอ่อน
                                            }
                                        ],
                                        absolutePosition: { x: 400, y: 85 }, // ปรับตำแหน่งตาม layout ของคุณ
                                    },
                                    {
                                        text: [
                                            { text: 'เลขที่เอกสาร: ', bold: true },
                                            { text: delivery.pending_delivery_number || '-', bold: false },

                                        ],
                                        margin: [0, 0, 20, 0],
                                    },
                                    {
                                        text: [
                                            { text: 'วันที่: ', bold: true },
                                            { text: dayjs(delivery.issue_date).format('DD/MM/YYYY'), bold: false }
                                        ],
                                        margin: [0, 0, 20, 0],
                                    },
                                    // {
                                    //     text: [
                                    //         { text: 'วันที่ส่งของ: ', bold: true },
                                    //         { text: dayjs(delivery.expected_date).format('DD/MM/YYYY'), bold: false }
                                    //     ],
                                    //     margin: [0, 2, 0, 0]
                                    // }
                                ],
                                alignment: 'left',
                                border: [false, false, false, false],
                                margin: [55, 25, 0, 0]
                            }
                        ]
                    ]
                },
                margin: [0, 0, 0, 0]
            },

            // ข้อมูลลูกค้า
            { text: 'ไม่ใช่ใบกำกับภาษี', bold: true, color: 'red', margin: [30, -25, 0, 0] },
            {
                lineHeight: 0.8,
                text: [
                    { text: `ลูกค้า: ${delivery?.customer_name || '-'}`, bold: false },
                    '\n',
                    { text: 'ที่อยู่: ', bold: false },
                    delivery?.customer_address || '-',
                    '\n',
                    { text: 'โทรศัพท์: ', bold: false },
                    delivery?.customer_phone || '-',
                    '\n',
                    { text: 'เลขที่ภาษี: ', bold: false },
                    delivery?.customer_tax_id || '-'
                ],
                margin: [30, 0, 0, 10]
            },

            // รายการสินค้า/บริการ
            {
                text: 'ทางบริษัทฯ ขอแจ้งรายการสินค้าค้างส่ง ดังต่อไปนี้',
                fontSize: 14,
                margin: [50, 0, 0, 10]
            },
            {
                table: {
                    headerRows: 0,
                    widths: [26, 69, '*', 60, 60],
                    body: [
                        [
                            { text: 'ที่', style: 'tableHeader', alignment: 'center' },
                            { text: 'รหัสสินค้า', style: 'tableHeader', alignment: 'center' },
                            { text: 'รายละเอียด', style: 'tableHeader', alignment: 'center' },
                            { text: 'จำนวน', style: 'tableHeader', alignment: 'center' },
                            { text: 'หน่วยนับ', style: 'tableHeader', alignment: 'center' },
                        ],
                        ...(delivery?.items || []).map((item, index) => [
                            { text: (index + 1).toString(), alignment: 'center' }, // ✅ ลำดับที่
                            { text: item.barcode || '-', alignment: 'center' }, //บาร์โค้ด
                            { text: `${item.description ? `${item.name}\n${item.description}` : item.name}` || '-', alignment: 'left' }, //รายละเอียดสินค้า
                            { text: `${item.pending_quantity?.toString() || 0}`, alignment: 'center' }, //จำนวนค้างส่ง
                            { text: `${item.unit?.toString()}`, alignment: 'center' }, //จำนวนค้างส่ง
                            // { text: `${item.quantity?.toString()} ${item.unit?.toString() || 0}`, alignment: 'center' }, //จำนวน
                            // { text: `${item.delivered_quantity?.toString()} ${item.unit?.toString() || 0}`, alignment: 'center' }, //จำนวนส่งแล้ว

                        ])
                    ]
                },
                // layout: {
                //     fillColor: function (rowIndex, node, columnIndex) {
                //         return (rowIndex === 0) ? '#eeeeee' : null;
                //     }
                // },
                layout: 'noBorders',
                margin: [0, 0, 0, 20]
            },

            //ส่วนท้ายของหน้ากระดาษ จะแสดงเฉพาะหน้าสุดท้ายเเท่านั้น

        ],

        footer: function (currentPage, pageCount) {
            if (currentPage !== pageCount) return {}; // แสดงเฉพาะหน้าสุดท้าย

            return {
                margin: [40, -200, 40, 0], // <— ดึงขึ้น (negative top margin สำคัญ)
                lineHeight: 0.9,   // <— ค่านี้ยิ่งน้อย บรรทัดจะยิ่งชิดกัน
                stack: [
                    // ==== 🎨 พื้นหลัง GRAND TOTAL เฉพาะแถวสุดท้าย ====
                    // {
                    //     canvas: [
                    //         {
                    //             type: 'rect',
                    //             x: 0,
                    //             y: 0,
                    //             w: 225,   // ✅ ความกว้างพื้นหลัง
                    //             h: 28,    // ✅ ความสูงหนึ่งแถว
                    //             r: 5,    // ✅ ขอบมน 10px
                    //             color: '#E3F2FD'
                    //         }
                    //     ],
                    //     // ✅ ต้องปรับตำแหน่งให้เข้ากับเอกสารของคุณ
                    //     // ค่านี้เบื้องต้น หากสูงเกิน/ต่ำไป แจ้งผมได้
                    //     absolutePosition: { x: 330, y: -116 }
                    // },
                    {
                        columns: [
                            {
                                lineHeight: 0.9,   // <— ค่านี้ยิ่งน้อย บรรทัดจะยิ่งชิดกัน
                                width: '55%',
                                style: 'bathText',
                                stack: [
                                    // เงื่อนไข
                                    {
                                        text: 'หมายเหตุ:',
                                        style: 'subheader',
                                        margin: [0, 10, 0, 0]
                                    },
                                    {
                                        text: `${delivery?.notes || '-'}`,
                                        margin: [20, 0, 0, 21], fontSize: 13

                                    },
                                    // {
                                    //     text: `${numberToThaiText(delivery.total_amount)}`,
                                    //     margin: [0, -3, 0, 0], fontSize: 18
                                    // }
                                ],
                                margin: [5, 0, 40, 0], // <— ดึงขึ้น (negative top margin สำคัญ)
                            },
                            // {
                            //     width: '53%',
                            //     table: {
                            //         body: [
                            //             // สำหรับ VAT INCLUDE - ใช้โครงสร้างเดิมแต่เปลี่ยนข้อความอธิบาย
                            //             [
                            //                 { text: 'รวมจำนวนเงิน (TOTAL AMOUNT):', alignment: 'right', fontSize: 15 },
                            //                 // { text: `${(formatCurrency(delivery.total_amount) || 0).toLocaleString()} บาท`, alignment: 'right', fontSize: 15 }
                            //             ],
                            //             [
                            //                 { text: 'ส่วนลด (DISCOUNT):', alignment: 'right', fontSize: 15 },
                            //                 // { text: `${(formatCurrency(delivery.discount) || 0).toLocaleString()} บาท`, alignment: 'right', fontSize: 15 }
                            //             ],
                            //             [
                            //                 { text: 'ราคาสินค้าไม่รวมภาษี (SUB TOTAL):', alignment: 'right', fontSize: 15 },
                            //                 // { text: `${(formatCurrency(delivery.subtotal) || 0).toLocaleString()} บาท`, alignment: 'right', fontSize: 15 }
                            //             ],
                            //             [
                            //                 { text: `ภาษีมูลค่าเพิ่ม (VAT):`, alignment: 'right', fontSize: 15 },
                            //                 // { text: `${(formatCurrency(delivery.tax_amount) || 0).toLocaleString()} บาท`, alignment: 'right', fontSize: 15 }
                            //             ],
                            //             [
                            //                 { text: 'รวมทั้งสิ้น (GRAND TOTAL):', bold: true, alignment: 'right', fontSize: 16 },
                            //                 // { text: `${formatCurrency(delivery.total_amount).toLocaleString()} บาท`, bold: true, alignment: 'right', fontSize: 16 }
                            //             ],
                            //         ]
                            //     },
                            //     layout: 'noBorders'
                            // }
                        ],
                        margin: [0, 0, 0, 20]
                    },

                    // ลายเซ็น
                    {
                        columns: [
                            {
                                width: '50%',
                                alignment: 'center',
                                text: [
                                    ' ',
                                    '\n\n',
                                    ' ',
                                    '\n',
                                    ' '
                                ],
                                fontSize: 16
                            },
                            {
                                width: '50%',
                                alignment: 'center',
                                text: [
                                    `${company.company_name}`,
                                    '\n\n',
                                    '________________________',
                                ],
                                fontSize: 16
                            }
                        ]
                    }
                ]
            };
        }

    };

    try {

        // สร้าง PDF
        const pdfDocGenerator = window.pdfMake.createPdf(docDefinition);

        return new Promise((resolve, reject) => {
            pdfDocGenerator.getDataUrl((dataUrl) => {
                if (dataUrl) resolve(dataUrl);
                else reject(new Error('ไม่สามารถสร้าง PDF preview ได้'));
            });
        });

        //return { success: true, fileName };
    } catch (error) {
        console.error('Error generating PDF:', error);
        throw new Error('ไม่สามารถสร้าง PDF ได้: ' + error.message);
    }
};

